export enum EProjectQueryKey {
  PROJECT = 'project',
  PROJECT_CERT_DETAILS = 'project-cert-details',
  RECENTLY_VISITED_PROJECTS = 'recently-visited-projects',
}
